import React, {useState} from 'react'
import './LoginForm.css'
import { RiLockPasswordFill } from "react-icons/ri";
import {useBrandLogo} from '../utilities/genreIcons';
import VrPortalLogo from "./VrPortalLogo";
import {useLoginBackgroundStyle} from "../utilities/loginBackground";
import {GenreIcon} from "../utilities/genreIcons";
import Swal from 'sweetalert2'
import {Link, Route, Routes, useNavigate} from "react-router-dom";
import SignupForm from "./SignupForm";
import {SIGNUP_ENABLED} from "../utilities/Constants";
import SimpleReactValidator from "simple-react-validator";
import {CircularProgress} from "@mui/material";
import {green} from "@mui/material/colors";
import {takeLoginReturn} from "../utilities/presentationChannel";

const REMEMBERED_USERNAME_KEY = 'rememberedUsername';

const LoginForm = () => {
    const loginBgStyle = useLoginBackgroundStyle();
    const ddLogo = useBrandLogo();
    const [username, setUsername] = useState(() => localStorage.getItem(REMEMBERED_USERNAME_KEY) || '');
    const [password, setPassword] = useState();
    const [unverifiedEmail, setUnverifiedEmail] = useState(null);
    const [resending, setResending] = useState(false);
    const [rememberMe, setRememberMe] = useState(() => !!localStorage.getItem(REMEMBERED_USERNAME_KEY));
    const navigate = useNavigate();
    const validator = new SimpleReactValidator();

    async function loginUser(credentials) {
        return fetch(`${process.env.REACT_APP_API_PROXY}/auth/signin`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        })
            .then(data => data.json())
    }

    const handleLogin = async e => {
        e.preventDefault();
        const response = await loginUser({
            username: username?.trim(),
            password
        });
        if ('accessToken' in response) {
            if (rememberMe) {
                localStorage.setItem(REMEMBERED_USERNAME_KEY, username?.trim() || '');
            } else {
                localStorage.removeItem(REMEMBERED_USERNAME_KEY);
            }
            Swal.fire({timer:1500,title:'Login Successful',icon:'success',showConfirmButton:false,position:'top',toast:true,
                didOpen:(toast)=>{const t=toast.querySelector('.swal2-title');const i=toast.querySelector('.swal2-icon');if(t){t.style.width='100%';t.style.textAlign='center';t.style.margin='0.5em 0';}
                    if(i){const spacer=document.createElement('div');spacer.style.gridColumn='3';spacer.style.width=(i.getBoundingClientRect().width+8)+'px';toast.appendChild(spacer);}}})
            // Swal.fire({
            //     timer: 2000,
            //     title: 'Login Successful',
            //     icon: 'success',
            //     showConfirmButton: false
            // })
                .then(async () => {
                    sessionStorage.setItem("user", JSON.stringify(response));
                    try {
                        // Backend's `active` flag (User.activeCampaignId) is authoritative across
                        // devices — always reconcile with it on login rather than trusting whatever
                        // this browser happened to have cached (which may be stale from before an
                        // explicit selection made on another device).
                        const campRes = await fetch(
                            `${process.env.REACT_APP_API_PROXY}/campaigns/getAllCampaignsForUser`,
                            {headers: {'Authorization': 'Bearer ' + response.accessToken}}
                        );
                        if (campRes.ok) {
                            const raw = await campRes.json();
                            const list = Array.isArray(raw) ? raw : [];
                            const backendActive = list.find(c => c.active === true);
                            let active = backendActive;
                            if (!active) {
                                const existingId = JSON.parse(localStorage.getItem("selectedCampaignId_" + response.username) || "null");
                                const hasValidId = existingId && !Array.isArray(existingId);
                                active = (hasValidId && list.find(c => c.id === existingId)) || list[0];
                            }
                            if (active) {
                                localStorage.setItem(
                                    "selectedCampaignId_" + response.username,
                                    JSON.stringify(active.id)
                                );
                            }
                        }
                    } catch (_) {}
                    // A table screen signing in for itself goes straight back to it.
                    const tableReturn = takeLoginReturn();
                    if (tableReturn) {
                        window.location.assign(tableReturn);
                        return;
                    }
                    navigate("/tavern");
                    window.location.reload();
                });
        } else if (response.emailNotVerified) {
            setUnverifiedEmail(response.email || null);
            Swal.fire({
                title: 'Email Not Verified',
                text: 'Please verify your email before logging in.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
        } else {
            Swal.fire({timer:2000,title:'Login Failed',text:response.message,icon:'error',showConfirmButton:false,position:'top',toast:true,
                didOpen:(toast)=>{const t=toast.querySelector('.swal2-title');const c=toast.querySelector('.swal2-html-container');const i=toast.querySelector('.swal2-icon');
                    if(t){t.style.width='100%';t.style.textAlign='center';t.style.margin='0.5em 0';}
                    if(c){c.style.width='100%';c.style.textAlign='center';}
                    if(i){const spacer=document.createElement('div');spacer.style.gridColumn='3';spacer.style.width=(i.getBoundingClientRect().width+8)+'px';toast.appendChild(spacer);}}});
        }
    }

    const handleResendVerification = async () => {
        const emailToResend = unverifiedEmail;
        if (!emailToResend) return;
        setResending(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_PROXY}/auth/resend-verification`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: emailToResend })
            });
            const data = await res.json();
            Swal.fire({
                timer: 3000,
                title: res.ok ? 'Email Sent' : 'Error',
                text: data.message || (res.ok ? 'Verification email resent.' : 'Could not resend email.'),
                icon: res.ok ? 'success' : 'error'
            });
        } catch {
            Swal.fire({ timer: 2000, title: 'Error', text: 'Could not resend email.', icon: 'error' });
        } finally {
            setResending(false);
        }
    }

    function logout() {
        sessionStorage.removeItem("user");
    }

    function getCurrentUser() {
        return JSON.parse(sessionStorage.getItem('user'));
    }

    return (
        <>
            <div>
                {/* Random pick from src/assets/login-backgrounds/<genre>/; without
                    one, the .login rule's own background shows. */}
                <div className="login" style={loginBgStyle}>
                    <div className="wrapper">
                        <form onSubmit={handleLogin}>
                            <img src={ddLogo} alt="DD_Logo" className="brand-logo brand-logo--lg"/>
                            <h1 className="brand-title">DropWyrm<span className="vtt">VTT</span></h1>

                            <div className="input-box">
                                <input type="text"
                                       placeholder='Username'
                                       value={username || ''}
                                       onChange={e => setUsername(e.target.value)}
                                       onBlur={validator.message('username', username, 'required', { className: 'text-danger' })}/>
                                <GenreIcon name="username" className="icon"/>
                            </div>

                            <div className="input-box">
                                <input type="password"
                                       placeholder='Password'
                                       onChange={e => setPassword(e.target.value)}
                                       onBlur={validator.message('password', password, 'required', { className: 'text-danger' })}/>
                                <RiLockPasswordFill className="icon"/>
                            </div>
                            <div className="remember-forgot">
                                <label><input type="checkbox"
                                              checked={rememberMe}
                                              onChange={e => setRememberMe(e.target.checked)}/>Remember me</label>
                                <Link to="/forgot-password">Forgot password?</Link>
                            </div>

                            <button type="submit">Login</button>

                            {unverifiedEmail && (
                                <div className="register-link" style={{ marginTop: '12px' }}>
                                    <p>
                                        Email not verified.{' '}
                                        <a href="#" onClick={e => { e.preventDefault(); handleResendVerification(); }}
                                           style={{ cursor: resending ? 'default' : 'pointer', opacity: resending ? 0.6 : 1 }}>
                                            {resending ? 'Sending…' : 'Resend verification email'}
                                        </a>
                                    </p>
                                </div>
                            )}

                            {SIGNUP_ENABLED && (
                                <div className="register-link">
                                    <p>Don't have an account? <Link to="/signup">Register</Link></p>
                                </div>
                            )}
                        </form>
                    </div>
                    {/* Logo pinned to bottom */}
                    <div style={{
                        position: 'absolute',
                        bottom: '10px',
                        right: '10px',
                        width: '96px',
                        height: '96px',
                        display: 'flex',
                        justifyContent: 'right',
                        alignItems: 'flex-end',
                        borderRadius: '12px', // Rounded corners
                    }}>
                        <a href="http://www.virtualrealmsstudios.com" target="_blank" rel="noreferrer"><VrPortalLogo width="96px" height="96px" alt="virtualStudiosLogo"/></a>
                    </div>
                    <div className="copyright-footer">
                        &copy; {new Date().getFullYear()} Virtual Realms Studios, LLC. All rights reserved.
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginForm;